export const roleDefinitions = [
  {
    value: 'super_user',
    label: 'Super User',
    description: 'Global administrator with full access to all colleges, users, folders, and content.',
    permissions: ['Manage every account', 'Manage every college', 'Edit any folder', 'Edit any content', 'Approve any workflow']
  },
  {
    value: 'college_admin',
    label: 'College Admin',
    description: 'Administrator scoped to one college. Can manage college users and folders.',
    permissions: ['Manage college accounts', 'Manage college folders', 'Create documents and exams']
  },
  {
    value: 'teacher',
    label: 'Teacher',
    description: 'Content creator who can manage their own material.',
    permissions: ['Create documents and exams', 'Manage owned folders', 'Manage owned content']
  },
  {
    value: 'student',
    label: 'Student',
    description: 'Learner account for browsing permitted content and taking tests.',
    permissions: ['Browse permitted content', 'Take tests', 'Use public and college content']
  },
  {
    value: 'guest',
    label: 'Guest',
    description: 'Unauthenticated visitor with public browse access only.',
    permissions: ['View public content']
  }
];

export const responsibilityDefinitions = [
  {
    value: 'account_management',
    label: 'Account Management',
    description: 'Create, deactivate, and maintain user accounts.',
    restrictedToSuperUser: true
  },
  {
    value: 'role_assignment',
    label: 'Role Assignment',
    description: 'Assign roles and responsibilities to eligible users.',
    restrictedToSuperUser: true
  },
  {
    value: 'college_scope_management',
    label: 'College Scope Management',
    description: 'Set or change the college scope for accounts.',
    restrictedToSuperUser: true
  },
  {
    value: 'email_verification',
    label: 'Email Verification',
    description: 'Verify email addresses for user accounts.',
    restrictedToSuperUser: true
  },
  {
    value: 'folder_stewardship',
    label: 'Folder Stewardship',
    description: 'Create, organize, move, and clean up folder structures.'
  },
  {
    value: 'content_creation',
    label: 'Content Creation',
    description: 'Upload documents and create exams for learners.'
  },
  {
    value: 'content_review',
    label: 'Content Review',
    description: 'Review learning material quality before it is used widely.'
  },
  {
    value: 'assessment_authoring',
    label: 'Assessment Authoring',
    description: 'Author and maintain exam questions and answer keys.'
  },
  {
    value: 'learner_support',
    label: 'Learner Support',
    description: 'Support students with access and learning workflow issues.'
  }
];

export const roleDefaults = {
  super_user: ['account_management', 'role_assignment', 'college_scope_management', 'email_verification', 'folder_stewardship', 'content_creation', 'content_review', 'assessment_authoring'],
  college_admin: ['folder_stewardship', 'content_creation', 'content_review', 'assessment_authoring', 'learner_support'],
  teacher: ['folder_stewardship', 'content_creation', 'assessment_authoring', 'learner_support'],
  student: ['learner_support']
};

export const roleLabel = (role) => roleDefinitions.find(item => item.value === role)?.label || role;

export const responsibilityLabel = (value) => responsibilityDefinitions.find(item => item.value === value)?.label || value;

export const visibleToUser = (viewer, account) => viewer?.role === 'super_user' || account.role !== 'super_user';
